module.exports = __webpack_public_path__ + "static/moores-law-b97c708c07b5ba7675c978b0a51c75ba.gif";